import React from 'react';
import './Footer.css';
import { ReactComponent as LogoGrey } from "../logo_grey.svg";
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container bg-neutral-900'>
      <section class='social-media'>
        <div class='social-media-wrap'>
          <div class='footer-logo'>
            <Link to='/' className='social-logo'>
              <LogoGrey className='md:w-[8rem] w-[6rem] text-white' />
              {/*<i class='fab fa-typo3' />*/}
            </Link>
          </div>
          <small class='website-rights'>ELIOVA © 2025</small>
          <div class='social-icons'>
            <Link
              class='social-icon-link facebook'
              to='/'
              target='_blank'
              aria-label='Facebook'
            >
              <i class='fab fa-facebook-f' />
            </Link>
            <Link
              class='social-icon-link instagram'
              to='/'
              target='_blank'
              aria-label='Instagram'
            >
              <i class='fab fa-instagram' />
            </Link>
            <Link
              class='social-icon-link youtube'
              to='/'
              target='_blank'
              aria-label='Youtube'
            >
              <i class='fab fa-youtube' />
            </Link>
            <a
              className='social-icon-link twitter'
              href='https://ca.linkedin.com/company/concepteliova'
              target='_blank'
              rel='noopener noreferrer'
              aria-label='LinkedIn'
            >
              {/* Icon or text goes here */}
              <i class='fab fa-linkedin' />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
